export const BaseUrl = 'https://adminpanel.visom6.com/admin/api';
export const WebUrl = 'https://adminpanel.visom6.com/admin/storage/app/public';
// export const BaseUrl = 'http://localhost:8000/api';
// export const WebUrl = 'http://localhost:8000/storage';